@if (control(); as control) {
  @if (!formModeService.isShowMode() && isTitleEditable()) {
    <procure-input-text
      #inputElement
      class="input"
      [label]="label()"
      [control]="control"
      [matTooltip]="tooltip()"
      [showMode]="formModeService.isShowMode()"
    />
  }
}
@if (formModeService.isShowMode() || !isTitleEditable()) {
  <h1 class="name">
    {{ titleValue() }}
    @if (revision(); as revision) {
      <span class="revision"> — {{ revision }} </span>
    }
    @if (titleValue(); as value) {
      <procure-copy-button
        tooltip="Copy entity name"
        [value]="value"
      />
    }
    <ng-content select="[titleSuffix]" />
  </h1>
}
